// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `boxx-custom-modal {
  --boxx-modal-header-background: var(--ion-color-medium, grey);
}

ion-avatar {
  width: 10px;
  height: 10px;
  border: none;
}

.not-specified {
  background: var(--ion-color-contact-chart-not-specified);
}

.prospect {
  background: var(--ion-color-contact-chart-prospect-color);
}

.client {
  background: var(--ion-color-contact-chart-client-color);
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/contacts-core/lib/components/contact-picker-type-modal/contact-picker-type-modal.scss"],"names":[],"mappings":"AAAA;EACE,6DAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,YAAA;AACF;;AAEA;EACE,wDAAA;AACF;;AAEA;EACE,yDAAA;AACF;;AAEA;EACE,uDAAA;AACF","sourcesContent":["boxx-custom-modal {\n  --boxx-modal-header-background: var(--ion-color-medium, grey);\n}\n\nion-avatar {\n  width: 10px;\n  height: 10px;\n  border: none;\n}\n\n.not-specified {\n  background: var(--ion-color-contact-chart-not-specified);\n}\n\n.prospect {\n  background: var(--ion-color-contact-chart-prospect-color);\n}\n\n.client {\n  background: var(--ion-color-contact-chart-client-color);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
